import React from 'react';
import {
  columnDataExists,
  columnRowCount,
  columnValidationDate,
  columnTools,
  hasColumn,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';

const DataManagementDictionariesTableColumns = ({ columns }) => (
  <NameDescriptionColumns entity="dictionary" columns={columns} toolsWidth={1}>
    {hasColumn(columns, columnDataExists) && <UnsortedColumn colWidth={1} columnId={columnDataExists} />}
    {hasColumn(columns, columnRowCount) && <UnsortedColumn textAlign="right" colWidth={1} columnId={columnRowCount} />}
    {hasColumn(columns, columnValidationDate) && <UnsortedColumn colWidth={1} columnId={columnValidationDate} />}
    {hasColumn(columns, columnTools) && <UnsortedColumn colWidth={1} />}
  </NameDescriptionColumns>
);

export default DataManagementDictionariesTableColumns;
